// extracted by mini-css-extract-plugin
export default {"pageTitle":"error_pageTitle__a2U6V","siteWidth":"error_siteWidth__-b2GF","errorPanel":"error_errorPanel__aVY9f"};